// import React, { useEffect } from "react";
// import "./Sidebar.scss";
// import { Link } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { getSidebarStatus, setSidebarOff } from "../../store/sidebarSlice";
// import {
//   fetchAsyncCategories,
//   getAllCategories,
// } from "../../store/categorySlice";

// const Sidebar = () => {
//   const dispatch = useDispatch();
//   const isSidebarOn = useSelector(getSidebarStatus);
//   const categories = useSelector(getAllCategories);

//   useEffect(() => {
//     dispatch(fetchAsyncCategories());
//   }, [dispatch, categories]);

//   return (
//     <aside className={sidebar ${isSidebarOn ? "hide-sidebar" : ""}}>
//       <button
//         type="button"
//         className="sidebar-hide-btn"
//         onClick={() => dispatch(setSidebarOff())}
//       >
//         <i className="fas fa-times"></i>
//       </button>
//       <div className="sidebar-cnt">
//         <div className="cat-title fs-17 text-uppercase fw-6 ls-1h">
//           All Vendors
//         </div>
//         <ul className="cat-list">
//           {categories.map((category, idx) => {
//             // Assurez-vous que category est un objet avec les propriétés attendues
//             const displayCategory =
//               typeof category === "object" && category !== null
//                 ? category.name.replace("-", " ") // Utilisez la propriété 'name' pour l'affichage
//                 : category;

//             return (
//               <li key={idx} onClick={() => dispatch(setSidebarOff())}>
//                 <Link
//                   to={category/${category.slug}} // Utilisez la propriété 'slug' pour l'URL
//                   className="cat-list-link text-capitalize"
//                 >
//                   {displayCategory}
//                 </Link>
//               </li>
//             );
//           })}
//         </ul>
//       </div>
//     </aside>
//   );
// };

// export default Sidebar;

import React, { useEffect } from "react";
import "./Sidebar.scss";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getSidebarStatus, setSidebarOff } from "../../store/sidebarSlice";
import { fetchAsyncVendors, getAllVendors, getVendorsStatus } from "../../store/vendorSlice";
import { STATUS } from "../../utils/status";

const Sidebar = () => {
    const dispatch = useDispatch();
    const isSidebarOn = useSelector(getSidebarStatus);
    const vendors = useSelector(getAllVendors);
    const vendorsStatus = useSelector(getVendorsStatus);

    useEffect(() => {
        dispatch(fetchAsyncVendors());
    }, [dispatch]);

    return (
        <aside className={`sidebar ${isSidebarOn ? "hide-sidebar" : ""}`}>
            <button
                type="button"
                className="sidebar-hide-btn"
                onClick={() => dispatch(setSidebarOff())}
            >
                <i className="fas fa-times"></i>
            </button>
            <div className="sidebar-cnt">
                <div className="cat-title fs-17 text-uppercase fw-6 ls-1h">
                    All Vendors
                </div>
                <ul className="cat-list">
                  
                    {vendorsStatus === STATUS.LOADING && <li>Loading vendors...</li>}
                    {vendorsStatus === STATUS.FAILED && <li>Error loading vendors.</li>}
                    {vendorsStatus === STATUS.SUCCEEDED && vendors.map((vendor) => (
                        <li key={vendor.id} onClick={() => dispatch(setSidebarOff())}>
                            <Link
                                to={`/vendor/${vendor.id}`} // Changer le chemin pour inclure l'ID du vendeur
                                className="cat-list-link text-capitalize"
                            >
                                {vendor.firstname} {vendor.lastname}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </aside>
    );
};

export default Sidebar;

